import router from './router';
import store from '../store';
import 'nprogress/nprogress.css';
import Api from '@/api';
// Progress 进度条样式
// import Api from '@/api';
const whiteList = ['404', 'login']; // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.name) > -1) {
    next();
    return;
  }
  store.dispatch('getUser').then((user) => {
    next();
  }).catch(() => {
    // window.location.href = `http://sso.ruijie.com.cn/login.php?URL=${window.location.href}`;
  });

  //   ----------------------------------------------------------
  // if (to.fullPath.indexOf('ticket') !== -1) {
  //   let routerUrl = '';
  //   if (to.fullPath.indexOf('route') !== -1) {
  //     routerUrl = to.fullPath.split('/login?route=')[1].split('&ticket=')[0];
  //   } else {
  //     routerUrl = '';
  //   }
  //   Api.user(to.query.ticket, encodeURIComponent(decodeURIComponent(routerUrl))).then(res => {
  //     if (res.data.status === '200') {
  //       // 判断是否有route 参数
  //       if (routerUrl !== '') {
  //         let toUrl = decodeURIComponent(routerUrl);
  //         if (window._env_.NODE_ENV !== 'pro') {
  //           window.location.href = `http://wpcuat.ruijie.com.cn/${toUrl}`;
  //         } else {
  //           window.location.href = `http://wpc.ruijie.com.cn/productrules/rules?${toUrl}`;
  //         }
  //       } else {
  //         next('/');
  //       }
  //     } else {
  //       console.log('ticket权限接口失败，将要跳转', to.path);
  //     }
  //   });
  // } else {
  //   next();
  // }
  // if (whiteList.indexOf(to.name) >= 0) { // 在免登录白名单，直接进入
  //   next();
  //   return;
  // }
  // next();
});

router.afterEach((to, from, next) => {
  // NProgress.done(); // 结束Progress
});
